
import { Vue, Options, prop } from "vue-class-component";
import { PaymentController } from "@/app/ui/controllers/PaymentController";
import { PaymentMethod } from "@/domain/entities/Payment";
import Cash from "@/app/ui/components/icons/modules/cash.vue";
import { GTMCommonEvent } from "@/app/infrastructures/misc/gtm-event/common-event";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  isDiscount = prop<boolean>({
    default: false
  });
  id = prop<string>({
    default: "",
    type: String
  });
  payment = prop<string>({
    default: "",
    type: String
  });
  configShowPayment = prop<boolean>({
    default: true,
    type: Boolean
  });
  isCreateBookingRetail = prop<boolean>({
    default: false
  });
  isCOD = prop<boolean>({
    default: false,
    type: Boolean
  });
  isDFOD = prop<any>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: { Cash }
})
export default class SelectPaymentMethods extends Vue.with(Props) {
  mounted() {
    this.payWithCash();
    this.togglePaymentMethods();
    PaymentController.getPaymentMethodsAvailable();
  }
  get paymentMethodActive() {
    return PaymentController.paymentMethod;
  }
  get paymentMethods() {
    return PaymentController.paymentMethods.filter(
      (payment: PaymentMethod) => payment.status === "active" && payment.name !== "pos_limit"
    );
  }

  showPaymentMethods = false;
  togglePaymentMethods() {
    if (this.accountIsNonForeign && this.configShowPayment) {
      this.showPaymentMethods = !this.showPaymentMethods;

      this.$nextTick(() => {
        if (this.showPaymentMethods) {
          this.cashTabIndex = 0;

          (this.$refs as any)?.paymentMethodCash?.focus?.();
        }
      });
    }
  }
  forceClosePaymentMethods() {
    this.showPaymentMethods = false;
  }
  isMouseDown = false;
  onFocusTrigger() {
    if (this.isMouseDown) return;

    this.togglePaymentMethods();
  }

  cashTabIndex = -1;
  paymentTabIndex = -1;
  onKeydownPayCash(e: KeyboardEvent) {
    if (e.key === "Escape" || e.key === "Tab") {
      setTimeout(() => {
        this.showPaymentMethods = false;
      }, 50);
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      this.paymentTabIndex = 0;
      (this.$refs as any)?.["paymentMethodItem-0"]?.focus();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      this.paymentTabIndex = 0;
      (this.$refs as any)?.["paymentMethodItem-1"]?.focus();
    }
  }
  onItemKeydown(e: KeyboardEvent, index: number) {
    if (e.key === "Escape" || e.key === "Tab") {
      this.cashTabIndex = -1;
      this.paymentTabIndex = -1;
      setTimeout(() => {
        this.showPaymentMethods = false;
      }, 50);
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();

      if (!index) {
        (this.$refs as any)?.[`paymentMethodItem-${index + 1}`]?.focus();
        return;
      }

      this.paymentTabIndex = -1;
      (this.$refs as any)?.paymentMethodCash?.focus?.();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();

      if (index) {
        (this.$refs as any)?.[`paymentMethodItem-${index - 1}`]?.focus();
        return;
      }

      this.paymentTabIndex = -1;
      (this.$refs as any)?.paymentMethodCash?.focus?.();
    }
  }

  payWithCash() {
    PaymentController.changeState("");
    PaymentController.changePaymentMethod(
      new PaymentMethod({
        name: "cash",
        title: "Tunai",
        method: "cash"
      })
    );
    this.togglePaymentMethods();
  }
  payWithQr(paymentMethod: PaymentMethod) {
    if (paymentMethod.status === "inactive") return;
    PaymentController.changeState("");
    PaymentController.changePaymentMethod(paymentMethod);
    this.togglePaymentMethods();
    if (
      paymentMethod.name === "bca_qris" ||
      paymentMethod.name === "ovo_qris"
    ) {
      const eventName = paymentMethod.name;
      GTMCommonEvent(`booking_pembayaran_${eventName}`);
    }
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }
}
